import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreviewChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7.333 9.167 3.667 3.666 3.667-3.666"
    />
  </svg>
);
export default SvgPreviewChevronDown;
